import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import BrandLogo from "./BrandLogo";

const LoadingScreen = () => {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDone(true), 2400);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="bb-loader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          data-testid="loader-screen"
        >
          <div className="relative flex h-[220px] w-[220px] flex-col items-center justify-center">
            <svg
              className="pointer-events-none absolute inset-0 z-0"
              width="220"
              height="220"
              viewBox="0 0 220 220"
              fill="none"
            >
              <motion.circle
                cx="110"
                cy="110"
                r="100"
                stroke="rgba(232,211,195,0.42)"
                strokeWidth="1"
                fill="none"
                strokeDasharray="628"
                initial={{ strokeDashoffset: 628 }}
                animate={{ strokeDashoffset: 0 }}
                transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
              />
              <motion.circle
                cx="110"
                cy="110"
                r="60"
                stroke="rgba(232,211,195,0.18)"
                strokeWidth="1"
                fill="none"
                strokeDasharray="377"
                initial={{ strokeDashoffset: 377 }}
                animate={{ strokeDashoffset: 0 }}
                transition={{ duration: 1.4, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
              />
            </svg>
            <motion.div
              className="relative z-10 flex items-center justify-center"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            >
              <div className="text-center">
                <BrandLogo height={36} theme="light" className="mx-auto" />
                <div
                  className="mt-2 label-meta text-champagne"
                  style={{ opacity: 0.7 }}
                >
                  Industrial Profile
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoadingScreen;
